import api from "../api";

export interface PendingRegistration {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  createdAt: string;
  metadata: any;
  membership?: {
    id: string;
    tenantId: string;
    roleId?: string;
  };
}

export interface RegistrationDetails extends PendingRegistration {
  documents: Array<{
    key: string;
    url: string;
    type: string;
    name: string;
  }>;
  profilePicture?: string;
  patronType?: { id: string; name: string } | null;
  homeBranch?: { id: string; name: string; code: string } | null;
  membershipJoinedAt?: string;
}

export interface ApproveRegistrationData {
  action: "approve" | "reject";
  notes?: string;
  homeBranchId?: string;
  patronTypeId?: string;
}

export interface BulkApproveRegistrationData {
  userIds: string[];
  action: "approve" | "reject";
  notes?: string;
}

export const registrationApprovalApi = {
  /**
   * Get all pending registrations
   */
  async getPendingRegistrations(): Promise<PendingRegistration[]> {
    const response = await api.get("/registration-approval/pending");
    return response.data;
  },

  async getRejectedRegistrations(): Promise<PendingRegistration[]> {
    const response = await api.get("/registration-approval/rejected");
    return response.data;
  },

  async getRejectedRegistrationDetails(userId: string): Promise<RegistrationDetails> {
    const response = await api.get(`/registration-approval/rejected/${userId}`);
    return response.data;
  },

  async reopen(userId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/registration-approval/${userId}/reopen`);
    return response.data;
  },

  /**
   * Get detailed information about a pending registration
   */
  async getRegistrationDetails(userId: string): Promise<RegistrationDetails> {
    const response = await api.get(`/registration-approval/pending/${userId}`);
    return response.data;
  },

  /**
   * Approve or reject a registration
   */
  async approveOrReject(
    userId: string,
    data: ApproveRegistrationData
  ): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/registration-approval/${userId}/action`, data);
    return response.data;
  },

  /**
   * Bulk approve or reject registrations
   */
  async bulkApproveOrReject(
    data: BulkApproveRegistrationData
  ): Promise<{ success: boolean; message: string; processed: number; failed: number }> {
    const response = await api.post("/registration-approval/bulk-action", data);
    return response.data;
  },
};
